export const Logo = ({ width = 104 }) => (
  <img
    src="/images/jai-homes-logo.png"
    alt="JAI HOMES — Licensed NSW Master Builder"
    data-testid="jai-logo"
    draggable={false}
    style={{ width, height: "auto" }}
    className="select-none object-contain"
  />
);
